const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左側圖片 */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/b5368372fbd14fa9050fc2c49711d59e.jpg"
                alt="亞立原團隊"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* 裝飾元素 */}
            <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-orange-500/20 rounded-full blur-3xl"></div>
          </div>

          {/* 右側內容 */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              關於<span className="text-orange-500">亞立原</span>
            </h2>
            
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              <strong>亞立原 Arion</strong> 是台灣領先的<strong>數位科技與創新服務品牌</strong>，我們專注於<strong>遊戲產品代理、研發與市場推廣</strong>，致力於為玩家帶來最優質的遊戲體驗。
            </p>

            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              我們深信，優秀的<strong>遊戲產品</strong>不僅需要創新的技術和精緻的內容，更需要專業的<strong>市場推廣</strong>和完善的<strong>玩家服務</strong>。透過我們的專業團隊和豐富經驗，我們成功地將多款優質遊戲引進台灣市場，並協助遊戲開發商實現商業目標。
            </p>

            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              從<strong>遊戲代理</strong>、<strong>產品研發</strong>到<strong>市場推廣</strong>，我們提供全方位的<strong>遊戲產業解決方案</strong>，鏈結創意與玩家體驗，打造卓越的遊戲生態系統。
            </p>

            <a 
              href="#services"
              className="inline-flex items-center bg-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap"
            >
              了解更多服務
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
